export default {
  title: "SORU3",
  text: `Bir çiftçinin baltası kaybolmuş. Çiftçi, komşusunun oğlundan şüphelenmiş çünkü çocuk bir hırsız gibi yürüyor, davranıyor ve bir hırsız gibi konuşuyormuş. Çiftçi ertesi gün baltasını aletlerin arasında bulmuş. Daha sonra komşusunun oğlunu arkadaşlarıyla oynarken görmüş. Çocuk bütün arkadaşları gibi yürüyor, davranıyor ve onlar gibi konuşuyormuş.`
};



// WEBPACK FOOTER //
// ./src/assets/goz-ritim/lgs/3.js